module.exports = __webpack_public_path__ + "img/pro_1.96d4a4f7.png";